(ns iris.posts.views.text-resizer
  (:require
   [re-frame.core :as re-frame]
   [iris.localstorage :as localstorage]
   [iris.posts.events :as posts-events]
   [iris.posts.subs :as posts-subs]))


(defn inc-font-size [e]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/inc-font-size]))

(defn dec-font-size [e]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/dec-font-size]))

(defn text-resizer []
  ;; TODO: look into re-frame co-effexts for loading default vals from local storage
  ;; (let [font-size (localstorage/get-item "iris.post.font-size")]
  ;;   (if (nil? font-size)
  ;;     (localstorage/set-item! "iris.post.font-size" 100)
  ;;     (re-frame/dispatch [::posts-events/set-font-size font-size])))
  (let [font-size (re-frame/subscribe [::posts-subs/font-size])]
    [:div.btn-group.btn-group-sm
     {:role "group"}

       [:a.btn.btn-primary {:title "Decrease font size"
                            :style {:width "28px"}
                            :on-click (fn [e] (dec-font-size e))} "-"]
       [:span.btn.disabled {:title "table view"
                            :class "btn-default"}
        (str @font-size) "%"]
       [:a.btn.btn-primary {:title "Increase font size"
                            :style {:width "28px"}
                            :on-click (fn [e] (inc-font-size e))} "+"]]))